import React, {useState} from 'react';
import {RiMenu3Line, RiCloseLine} from 'react-icons/ri'
import './navbar.css';

const Menu = () => (
  <>
  <p><a href="#home">Home</a></p>
  <p><a href="#possibility">Method</a></p>
  <p><a href="#contact">Contact</a></p>
  </>
)

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  return (
    <div className="gpt3__navbar">
      <div className="gpt3__navbar-links">
        <div className="gpt3__navbar-links_logo">
          <a href="#home">Lake Champlain PT</a>
        </div>
        <div className="gpt3__navbar-links_container">
          <Menu />
        </div>
      </div>
      <div className="gpt3__navbar-sign">
        <p><a href="tel:+15185974678">(518) 597-4678</a></p>
      </div>
      <div className="gpt3__navbar-menu">
        {toggleMenu
        ? <RiCloseLine color="#0f2d3a" size={27} onClick={() => setToggleMenu(false)}/>
        : <RiMenu3Line color="#0f2d3a" size={27} onClick={() => setToggleMenu(true)}/>
        }
        {toggleMenu && (
          <div className="gpt3__navbar-menu_container scale-up-center">
            <div className="gpt3__navbar-menu_container-links">
              <Menu />
              <div className="gpt3__navbar-menu_container-links-sign">
                <p><a href="tel:+15185974678">(518) 597-4678</a></p>
              </div>
            </div> 
          </div>
        )}
      </div>
    </div>
  )
}

export default Navbar
